
import { CreateCustomer, CreateCustomerToken } from "$src/application/customers/commands/CreateCustomer";
import { CreateCustomerData } from "$src/domain/customers/CreateCustomerData";
import { CustomerIdentifier } from "$src/domain/customers/CustomerIdentifier";
import { useMutation, useQueryClient } from "@sveltestack/svelte-query";
import { container } from "tsyringe";

export async function createCustomer(groupStoreId: number, data: CreateCustomerData)
    : Promise<CustomerIdentifier> {

    const query = container.resolve<CreateCustomer>(CreateCustomerToken);
    return query.execute(groupStoreId, data);
}

export function useCreateCustomer() {
    const queryClient = useQueryClient();

    return useMutation(
        ({ groupStoreId, data}: 
            { groupStoreId: number, data: CreateCustomerData }
        ) => createCustomer(groupStoreId, data),
        {
            onSuccess: (data, variables) => {
            },
            onError: (error: Error) => {
                console.error('Failed to create customer:', error);
            },
            onSettled: () => {
            },
        }
    );
}